window.cookieconsent_options = {
    message: 'Ez a weboldal cookie-kat (sütiket) használ azért, hogy weboldalunk használata során a lehető legjobb élményt tudjuk biztosítani. A weboldalunkon történő további böngészéssel hozzájárul a cookie-k használatához. ',
    learnMore: 'Bővebb információ',
    dismiss: 'Rendben',
    theme: 'dark-bottom',
    link: '/suti-hasznalati-szabalyzat'
};
